import { render, staticRenderFns } from "./SectionHeadings.vue?vue&type=template&id=6487ad4d&scoped=true&"
import script from "./SectionHeadings.vue?vue&type=script&lang=js&"
export * from "./SectionHeadings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487ad4d",
  null
  
)

export default component.exports